export const sessionStoryEnglish = {
  title: "Work session — {{date}}",
  summary: "Session summary",
  mappedTime: "mapped time",
  processes: "processes",
  apps: "apps used",
  placeholder: "Placeholder",
  summaryPlaceholder:
    "A short summary of this work session will appear here, describing the main work and how it unfolded.",
  whatHappened: "What happened",
  timelineDescription:
    "The work performed during this session, grouped by process. Select a block to explore its steps.",
  browseScreenshots: "Browse screenshots",
  processList: "Processes in this session",
  detected: "{{count}} processes detected",
  instance: "Case {{num}}",
  noScreenshots: "No screenshots are attached to this analysis",
  instances: "{{count}} cases",
  instances_one: "{{count}} case",
  instances_other: "{{count}} cases",
  showLess: "Show fewer processes",
  highlights: "Session highlights",
  mostRepeated: "Most repeated process",
  mostTime: "Most time spent",
  topApp: "Top app",
  highestActivity: "Highest activity period",
  showFullSession: "Show full session",
  changes: "{{count}} step changes in 15 min",
  changes_one: "{{count}} step change in 15 min",
  changes_other: "{{count}} step changes in 15 min",
  share: "({{percent}}%)",
  noAppData: "App usage is unavailable for this analysis",
  allProcesses: "All processes",
  showAllProcesses: "Show all {{count}} processes",
  runCount: "{{count}} cases",
  runCount_one: "{{count}} case",
  runCount_other: "{{count}} cases",
  run: "Case {{num}}",
  evidence: "Session walkthrough",
  steps: "Steps",
  scope: "Browse scope",
  screenshotCounts: "Screenshot counts",
  stepScreenshotCount: "Screenshot {{current}} of {{total}} in this step",
  runScreenshotCount: "Screenshot {{current}} of {{total}} in this case",
  processScreenshotCount: "Screenshot {{current}} of {{total}} in this process",
  sessionScreenshotCount: "Screenshot {{current}} of {{total}} in this session",
  thisRun: "This case",
  thisProcess: "This process",
  entireSession: "Entire session",
  previousStep: "Previous step",
  nextStep: "Next step",
  stepCount: "Step {{current}} of {{total}}",
  selectStep: "Go to step",
  searchSteps: "Search steps",
  noMatchingSteps: "No steps match your search",
  fullscreen: "View screenshot fullscreen",
  noStepScreenshots: "No screenshots for this step",
  noSteps: "No steps are available for this case",
};
